import { render, staticRenderFns } from "./TestTag.vue?vue&type=template&id=43cd5931&scoped=true"
import script from "./TestTag.vue?vue&type=script&lang=js"
export * from "./TestTag.vue?vue&type=script&lang=js"
import style0 from "./TestTag.vue?vue&type=style&index=0&id=43cd5931&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cd5931",
  null
  
)

export default component.exports